import React from "react";
import Container from "components/Container";
import {Hero, Works} from "./components";
import {Box} from "@material-ui/core";

const Obras = () => {
    const listTemporalPublicas = [
        {
            nameComunidad: "Tuxtepec",
            description:
                "Instalacion de alumbrado",
            actaAproved: {
                status: "A",
                link: "http://setracoahuila.gob.mx/descargar/Contrato%20tiempo%20indeterminado.pdf",
            },
            contratoPublic: {
                status: "A",
                link: "http://setracoahuila.gob.mx/descargar/Contrato%20tiempo%20indeterminado.pdf",
            },
            Estimaciones: {
                status: "P",
                link: "",
            },
            lineTime: 50,
        },
        {
            nameComunidad: "Progreso",
            description:
                "Pavimentacion de Avenida principal",
            actaAproved: {
                status: "C",
                link: "",
            },
            contratoPublic: {
                status: "C",
                link: "",
            },
            Estimaciones: {
                status: "C",
                link: "",
            },
            lineTime: 0,
        },
        {
            nameComunidad: "San bartolo",
            description:
                "Pavimentacion del puente",
            actaAproved: {
                status: "A",
                link: "http://setracoahuila.gob.mx/descargar/Contrato%20tiempo%20indeterminado.pdf",
            },
            contratoPublic: {
                status: "A",
                link: "http://setracoahuila.gob.mx/descargar/Contrato%20tiempo%20indeterminado.pdf",
            },
            Estimaciones: {
                status: "A",
                link: "http://setracoahuila.gob.mx/descargar/Contrato%20tiempo%20indeterminado.pdf",
            },
            lineTime: 100,
        },
    ];
    return (
        <Box>
            <Hero/>
            <Container>

            </Container>
            <Container>
                <Works listObrasPublicas={listTemporalPublicas}/>
            </Container>
        </Box>
    );
};

export default Obras;
